module.exports = __webpack_public_path__ + "static/008249-70de8d23ae4b8e1c06564dcc544230a2.jpg";